import useEventStore, { agendas, events } from '../../stores/eventStore';
import styles from './agendaForm.module.scss';

export const AgendaForm = () => {
	const { activeTab } = useEventStore();
	const event = events.find((e) => e.topic === activeTab);
	const group = agendas.find((e) => e.topic === activeTab);
	const agendaData = group?.items || [];

	return (
		<div className={styles.agendaForm}>
			<div className={styles.title}>
				{/* d-flex justify-content-center */}
				<img
					className={styles.titleImage}
					src={event.titleImage}
					alt='[ 護心同行：安穩跳動，自在生活 ]'
				/>
			</div>
			<div className={styles.agendaTitle}>
				<span>精彩議程</span>
			</div>
			<div className={styles.agendaWrapper}>
				<div className={styles.agendaHeaderContainer}>
					<div className={styles.agendaHeader}>
						<div className={styles.agendaHeaderPlace}>
							<b>地點</b>
						</div>
						<div className={styles.agendaHeaderAddress}>
							<b>政大公企中心 10F A1034 會議教室</b>
							<br className='d-lg-none' /> (台北市大安區金華街 187 號)
						</div>
					</div>
				</div>
				<div className={styles.agendaBody}>
					{agendaData.map((item, index) => (
						<div className={styles.agendaRow} key={index}>
							<div className={styles.time}>{item.time}</div>
							<div className={styles.topic}>{item.topic}</div>
							<div className={styles.speaker}>
								<span className={styles.speakerName}>
									{item.speaker}
									<br />
								</span>
								<span className={styles.speakerPosition}>
									{item.position.split('\n').map((line, i) => (
										<div key={i}>{line}</div>
									))}
								</span>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
